import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { HTMLAttributeAnchorTarget, ReactNode } from 'react';

type PaymentCompanySupportLinkProps = {
  title: string;
  href: string;
  children: React.ReactNode;
  target?: HTMLAttributeAnchorTarget;
  rel?: string;
};

const PaymentCompanySupportLink = ({
  children,
  title,
  href,
  target,
  rel,
}: PaymentCompanySupportLinkProps): ReactNode => {
  const theme = useTheme();

  return (
    <Stack
      direction='row'
      spacing={1}
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: theme.typography.pxToRem(14),
      }}
    >
      <Typography
        sx={{
          color: theme.palette.text.primary,
          fontWeight: theme.typography.fontWeightBold,
        }}
      >
        {title}:
      </Typography>
      <Link color='tertiary.main' href={href} target={target} rel={rel}>
        <Typography fontSize='inherit'>{children}</Typography>
      </Link>
    </Stack>
  );
};

export default PaymentCompanySupportLink;
